<p-dialog
  header="Histórico de Apontamentos{{ ticketNumber ? ' - #' + ticketNumber : '' }}"
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{
    width: '90vw',
    'max-width': '850px',
    height: '90vh',
    'max-height': '90vh',
  }"
  [baseZIndex]="10000"
  [breakpoints]="{ '768px': '95vw', '480px': '100vw' }"
  (onHide)="onHide()"
  [styleClass]="getDialogStyleClass()"
  [contentStyle]="{
    padding: '0',
    height: 'calc(90vh - 130px)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  }">
  <!-- Dono único da rolagem: o contentStyle acima é flex column com overflow hidden, então é
       este wrapper que preenche o espaço restante e rola. -->
  <div class="modal-content-wrapper">
    @if (loading()) {
      <div class="history-skeleton">
        @for (row of [1, 2, 3, 4]; track row) {
          <p-skeleton height="7rem" styleClass="mb-3" />
        }
      </div>
    } @else if (loadError()) {
      <!-- Estado de erro separado do vazio de propósito: "não consegui carregar" e "este chamado
           não tem apontamento" são mensagens opostas e não podem parecer a mesma coisa. -->
      <div class="history-error">
        <i class="pi pi-exclamation-triangle"></i>
        <p>Não foi possível carregar os apontamentos deste chamado.</p>
      </div>
    } @else {
      <app-time-entry-history
        [entries]="entries()"
        [activeEntry]="activeEntry()"
        [readOnly]="true" />
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="form-actions">
      <p-button label="Fechar" icon="pi pi-times" severity="secondary" (onClick)="onHide()" />
    </div>
  </ng-template>
</p-dialog>
